import { useMediaQuery, useTheme } from "@mui/material";

export const useGtXs = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
}
